import { Box, Dialog, makeStyles, Tab, Tabs, Tooltip, withStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import clsx from "clsx";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import { OnClickAnchor } from "../../parts/OnClickAnchor";
import { adminSettingVisibleState } from "../../store/AdminSettingVisibleState";
import { CoPilotSettingBox } from "./CoPilotSetting";
import { AircraftSettingBox } from "./AircraftSetting";
import { useCallback } from "react";
import { PointAreaSettingBox } from "./PointAreaSetting";
import AirportGroupSetting from "./AirportGroupSetting";
import { ChartSettingBox } from "./ChartSetting";
import { ThresholdSettingBox } from "./ThresholdSetting";

const useStyles = makeStyles({
	root: {
		flexGrow: 1,
	},
	dialogRoot: {
		margin: '32px 32px 54px', // footer(+20px)
		'& .MuiBackdrop-root': {
			background: 'none',
		}
	},
	widgetRoot: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	widgetBody: {
		height: '100%',
		flex: 1,
		overflow: 'hidden',
	},
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export const StyledTabs = withStyles({
	root: {
		minHeight: '24px',
	},
	indicator: {
		display: 'none',
		justifyContent: 'center',
		backgroundColor: 'transparent',
	},
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const StyledTab = withStyles((theme) => ({
	root: {
		textTransform: 'none',
		color: '#fff',
		backgroundColor: '#a7a7a7',
		boxShadow: '2px 2px 2px rgb(255 255 255) inset',
		fontWeight: theme.typography.fontWeightRegular,
		fontSize: theme.typography.pxToRem(15),
		opacity: 1,
		minHeight: '24px',
		marginRight: '-1px',
		'&.Mui-selected': {
		},
		maxWidth: 'none',
		'&:first-child': {
			marginLeft: -3,
		},
	},
	selected: {
		color: '#4c4f53',
		backgroundColor: '#f1f1f1',
		fontWeight: 600,
	}
}))((props) => <Tab disableRipple {...props} />);

function AdminSettingPanel() {
	const [adminSettingVisible, setAdminSettingVisible] = useRecoilState(adminSettingVisibleState);

	const hidden = !adminSettingVisible;
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const changeCoPilotSetting = useCallback(() => {
		setValue(0);
	}, []);

	const changeAircraftSetting = useCallback(() => {
		setValue(1);
	}, []);

	const closeClickHandler = () => {
		setAdminSettingVisible(!adminSettingVisible);
	}

	const {t} = useTranslation();
	const classes = useStyles();

	return (
		<Dialog
			fullWidth
			fullScreen
			maxWidth={false}
			open={!hidden}
			className={classes.dialogRoot}
		>
			<div className={clsx("widget-box", "dark-color", classes.widgetRoot)}>
				<div className="widget-header"><h4>{t('Company Setting')}</h4>
					<div className="widget-toolbar">
						<OnClickAnchor onClick={closeClickHandler}>
							<Tooltip title="Close" arrow >
								<CloseIcon/>
							</Tooltip>
						</OnClickAnchor>
					</div>
				</div>
				<div id="plan-widget-body" className={clsx("widget-body", classes.widgetBody, classes.settingTopBox)}>
					<Box className={classes.settingTab}>
						<StyledTabs
							value={value}
							onChange={handleChange}
						>
							<StyledTab label={t('FOSTER-CoPilot Setting')} />
							<StyledTab label={t('Aircraft Setting')} />
							<StyledTab label={t('Point and Area Setting')} />
							<StyledTab label={t('Airport Group Setting')} />
							<StyledTab label={t('Threshold Setting')} />
							<StyledTab label={t('Chart Setting')} />
						</StyledTabs>
					</Box>
					<Box className={classes.settingBody} style={{ padding: '10px' }}>
						{!hidden &&
							value === 0 && <CoPilotSettingBox changeAircraftSetting={changeAircraftSetting} />
						}
						{!hidden &&
							value === 1 && <AircraftSettingBox changeCoPilotSetting={changeCoPilotSetting} />
						}
						{!hidden &&
							value === 2 && <PointAreaSettingBox />
						}
						{!hidden &&
							value === 3 && <AirportGroupSetting />
						}
						{!hidden &&
							value === 4 && <ThresholdSettingBox />
						}
						{!hidden &&
							value === 5 && <ChartSettingBox />
						}
					</Box>
				</div>
			</div>
		</Dialog>
	);
}

export default AdminSettingPanel;
